/**
 * Offset-paginated controller-scope PLC tags for a Controller or Program.
 *
 * A Controller returns every directly owned `PLCTag`. A Program returns only
 * directly owned controller tags referenced by one of its Routines through
 * `READS_TAG` or `WRITES_TAG`.
 *
 * Params: `{ nodeId: string; skip: number; pageSize: number }`.
 */
export const PLANT_PLC_CONTROLLER_TAGS_CYPHER = `
            MATCH (n {id: $nodeId})
              WHERE n:Controller OR n:Program
            WITH n, labels(n) AS labelList

            CALL {
              WITH n, labelList
              OPTIONAL MATCH (n)-[:HAS_TAG]->(ct:PLCTag)
                WHERE 'Controller' IN labelList
              RETURN collect(distinct ct) AS controllerTags
            }
            CALL {
              WITH n, labelList
              OPTIONAL MATCH (n)-[:BELONGS_TO]->(pc:Controller)
                -[:HAS_TAG]->(pt:PLCTag)
                <-[:READS_TAG|WRITES_TAG]-(r:Routine)-[:BELONGS_TO]->(n)
                WHERE 'Program' IN labelList
              RETURN collect(distinct pt) AS programReferencedTags
            }

            WITH controllerTags + programReferencedTags AS rawTags
            UNWIND (CASE WHEN size(rawTags) = 0 THEN [null] ELSE rawTags END) AS tag
            WITH DISTINCT tag
              ORDER BY toLower(coalesce(tag.name, '~~~~')), tag.id
            WITH size([t IN collect(tag) WHERE t IS NOT NULL]) AS totalTags,
                 [t IN collect(tag) WHERE t IS NOT NULL] AS sortedTags

            UNWIND (CASE WHEN size(sortedTags) = 0 THEN [null] ELSE sortedTags END) AS pageTag
            WITH totalTags, pageTag
            SKIP toInteger($skip)
            LIMIT toInteger($pageSize)
            WITH totalTags, [t IN collect(pageTag) WHERE t IS NOT NULL] AS pageTags

            UNWIND (CASE WHEN size(pageTags) = 0 THEN [null] ELSE pageTags END) AS pageTag
            OPTIONAL MATCH (pageTag)-[mapEdge:MAPS_TO_TAG]->(st:Tag)
              WHERE pageTag IS NOT NULL
            OPTIONAL MATCH (stTp:TagProvider)-[:PROVIDES]->(st)
            OPTIONAL MATCH (stHost:Compute)-[:HAS_TAG_PROVIDER]->(stTp)
            WITH totalTags, pageTags, collect({
              plcTagId: CASE WHEN pageTag IS NULL THEN NULL ELSE pageTag.id END,
              tag: st,
              edge: CASE WHEN mapEdge IS NULL THEN NULL ELSE type(mapEdge) END,
              sourceId: CASE WHEN pageTag IS NULL THEN NULL ELSE pageTag.id END,
              props: CASE WHEN mapEdge IS NULL THEN {} ELSE properties(mapEdge) END,
              providerId: CASE WHEN stTp IS NULL THEN NULL ELSE stTp.id END,
              hostId: CASE WHEN stHost IS NULL THEN NULL ELSE stHost.id END,
              hostUrl: CASE WHEN stHost IS NULL THEN NULL ELSE coalesce(stHost.url, stHost.gateway_url) END,
              project: CASE WHEN stHost IS NULL THEN NULL ELSE coalesce(stHost.web_dev_project, stHost.project) END
            }) AS rawScadaRows

            RETURN totalTags, pageTags AS tags,
                   [r IN rawScadaRows
                      WHERE r.tag IS NOT NULL AND r.plcTagId IS NOT NULL]
                     AS plcTagScadaRows
          `
